/* LUCIELL — Baukasten "Dein Verein" als ANGEBOTS-Variante (sections/lc-dein-verein-angebot.liquid)

   Kopie von assets/lc-dein-verein.js (Live-Stand 14.10.2026). Die Live-Seite
   /pages/dein-verein laeuft unveraendert weiter mit lc-dein-verein.js. Neu hier:

   1. Bis zu 8 Gravur-Charms (daten.gravurMax, Liquid rendert genau so viele
      Felder und Optionen). pruefen() lehnt mehr ab.
   2. Logo-Charm mit Anzahl (Betreiber 14.10.2026): dasselbe Logo x N. In den Korb
      geht EINE Zeile CH-LOGO mit quantity N und EINER Datei (Kasse geprueft:
      Menge 2 + eine Datei = 29,80 EUR). Grenze daten.logoMax.
   3. Schritt ① „Angebot & Farbe" (Betreiber 14.10.2026): Farbkacheln und
      Groessenknoepfe gibt es hier nicht mehr. Der Block snippets/lc-verein-angebot
      (Kasten 1 „1 Armband", Kasten 2 „Kauf 1, krieg 1 gratis") waehlt Armband 1
      UND das zweite Band und meldet beides ueber
        window.lcVereinAngebot = { modus: 'einzeln' | 'paar',
                                   band1: { variantId: Zahl, ... } | null,
                                   zweitesBand: { variantId: Zahl, preis?: Cent } | null }
      (auch als Funktion, die so ein Objekt liefert). band1 ist der Hauptposten
      (das Armband mit den Charms), die Galerie folgt seiner Farbe (Punkt 4). Fehlt
      der Block ganz (window.lcVereinAngebot undefined), kauft der Baukasten
      seine Startvariante (daten.start) einzeln. Bei 'paar' faehrt das zweite
      Band (Menge 1, ohne Eigenschaften) in DERSELBEN /cart/add.js mit wie Band,
      Logo, Gravuren, Foto und Extras — ein zweiter Aufruf binnen 2,5 s wiese
      lc-korb.js stumm ab. Armband 1 oder ('paar') zweites Band nicht lieferbar:
      kein Kauf, Meldung im Schritt "angebot". Neu gezeichnet wird bei jedem
      Klick/Wechsel auf der Seite und beim Ereignis `lc:verein-angebot`
      (document), wenn sich die Wahl geaendert hat. Leiste und Kopf rechnen dann
      1+1: das guenstigere Band gratis.
   4. Galerie nach Farbe (Ansage des Betreibers 14.10.2026): Liquid gibt nur die Bilder
      aus, deren Alt-Text eine Bandfarbe nennt (data-lc-dv-farbe an Folie und Punkt), und
      zeigt die der Startfarbe. Wechselt die Farbe von Armband 1, tauschen Folien und
      Punkte mit (sichtbareFolien). Ohne Farbmerkmale bleibt die alte Galerie.

   Band + Logo-Charm + Gravur-Charms + Foto-Charm + Extra-Charms (+ Band 2) gehen
   mit EINEM Aufruf in den Korb: lcKorb.hinzufuegen(band, 1, {}, weitere,
   'dein-verein', optionen). Shopify legt mehrere Zeilen atomar an (gemessen
   12.09.2026, siehe addAusfuehren in lc-korb.js): scheitert eine, kommt gar
   nichts in den Korb. Steckt eine Datei darin (Logo/Foto), schickt lc-korb.js die
   Anfrage mehrteilig (Easify-Ersatz).

   Bilder bereitet lc-personalisierung.js auf (EXIF-Drehung, lange Kante <= 2560).
   Fehlt das Skript, geht die Datei unveraendert raus.

   Die Herkunft 'dein-verein' steht (noch) nicht in der Liste von lc-metrik.js und
   wird dort zu null. Das ist Absicht, siehe Spec 3.4 des Baukastens.

   Spec Baukasten: docs/superpowers/specs/2026-09-22-dein-verein-baukasten-design.md */
(function () {
  'use strict';

  var MAX = 12;
  var GRAVUR_MAX = 8;      // Rueckfall, wenn daten.gravurMax fehlt
  var LOGO_MAX = 4;        // Rueckfall, wenn daten.logoMax fehlt
  var TEXTE = {
    keineGravur: 'Wähle mindestens einen Gravur-Charm.',
    zuVieleGravuren: 'Höchstens {n} Gravur-Charms.',
    zweitesBandFehlt: 'Bitte wähle Farbe und Größe für dein zweites Armband.',
    bandFehlt: 'Bitte wähle Farbe und Größe für dein Armband.',
    gratisBand: '1+1: Das günstigere Armband schenken wir dir',
    gravurLeer: 'Bitte fülle alle Gravurfelder aus.',
    fehler: 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    bildFehler: 'Bitte wähle ein Foto als JPG oder PNG',
    knopf: 'In den Warenkorb',
    laeuft: 'Wird hinzugefügt …',
    upload: 'Fotos werden hochgeladen … ',
    fertig: 'Im Warenkorb ✓',
    vorbereiten: 'Bild wird vorbereitet …',
    gratisVersand: 'Gratis-Versand',
    bisVersand: ' bis Gratis-Versand'
  };

  // Shopify-Geldformat, z. B. "€{{amount_with_comma_separator}}". Ohne Format
  // die deutsche Schreibweise.
  function geld(cent, format) {
    var betrag = (Math.round(cent) / 100).toFixed(2);
    var f = format || '{{amount_with_comma_separator}} €';
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, betrag.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, betrag)
      .replace(/<[^>]*>/g, '');
  }

  // Eine Grenze fuer alle Wege: lcKorb.gravur (Easify-Ersatz). Ohne lc-korb.js
  // zaehlt der Rueckfall Codepoints, damit ein Emoji nie zerschnitten wird.
  function grenze() { return (window.lcKorb && window.lcKorb.gravur) || null; }
  function kuerzen(text) {
    var g = grenze();
    if (g && typeof g.kuerzen === 'function') return g.kuerzen(text);
    return Array.from(String(text == null ? '' : text)).slice(0, MAX).join('');
  }
  function zaehlen(text) {
    var g = grenze();
    if (g && typeof g.zaehlen === 'function') return g.zaehlen(text);
    return Array.from(String(text == null ? '' : text)).length;
  }

  function variante(varianten, farbe, groesse) {
    for (var i = 0; i < varianten.length; i++) {
      if (varianten[i].farbe === farbe && varianten[i].groesse === groesse) return varianten[i];
    }
    return null;
  }

  // Faellt auf das erste Variantenbild derselben Farbe zurueck, wenn die exakte
  // Farbe x Groesse kein eigenes Bild hat.
  function bildFuerFarbe(varianten, farbe, groesse) {
    var v = variante(varianten, farbe, groesse);
    if (v && v.bild) return v.bild;
    for (var i = 0; i < varianten.length; i++) {
      if (varianten[i].farbe === farbe && varianten[i].bild) return varianten[i].bild;
    }
    return null;
  }

  // Galerie: Index des Bilds fuer Farbe x Groesse, gesucht ueber die Bild-ID wie
  // bildFuerFarbe. -1, wenn die Farbe kein Bild in der Galerie hat.
  // Nur noch im Rueckfall ohne Farbmerkmale an den Folien, siehe sichtbareFolien.
  function slideFuerFarbe(varianten, farbe, groesse, ids) {
    var v = variante(varianten, farbe, groesse);
    var id = v && v.bildId;
    for (var i = 0; !id && i < varianten.length; i++) {
      if (varianten[i].farbe === farbe && varianten[i].bildId) id = varianten[i].bildId;
    }
    return id ? ids.indexOf(String(id)) : -1;
  }

  /* Galerie nach Farbe (Ansage des Betreibers 14.10.2026): sichtbar sind nur die Bilder der
     gewaehlten Farbe. folienFarben = data-lc-dv-farbe je Folie (null/'' = ohne Merkmal),
     Ergebnis = Indizes der Folien, die zu zeigen sind. Zwei Rueckfaelle, damit die Galerie
     nie leer ist: traegt keine Folie eine Farbe (Liquid fand keine Farb-Alt-Texte) oder hat
     die Farbe keine Folie, sind es alle. Gilt genauso fuer die Punkte. */
  function sichtbareFolien(folienFarben, farbe) {
    var alle = [];
    var eigene = [];
    (folienFarben || []).forEach(function (f, i) {
      alle.push(i);
      if (f != null && f !== '' && f === farbe) eigene.push(i);
    });
    return eigene.length ? eigene : alle;
  }

  function extraPreis(daten, id) {
    for (var i = 0; i < daten.extras.length; i++) {
      if (String(daten.extras[i].variante) === String(id)) return daten.extras[i].preis;
    }
    return 0;
  }

  function ganzePositiv(x) {
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x && x >= 1;
  }

  // Obergrenzen aus den Section-Daten (Liquid: gravur_max / logo_max, je 1..8).
  function grenzeAus(wert, rueckfall) {
    var n = Number(wert);
    if (!ganzePositiv(n)) return rueckfall;
    return Math.min(n, 8);
  }
  function gravurMax(daten) { return grenzeAus(daten && daten.gravurMax, GRAVUR_MAX); }
  function logoMax(daten) { return grenzeAus(daten && daten.logoMax, LOGO_MAX); }

  // Anzahl Logo-Charms: ganze Zahl in [1, max]. Alles Unbrauchbare wird 1.
  function logoMenge(n, max) {
    var m = Math.floor(Number(n));
    if (!isFinite(m) || m < 1) m = 1;
    var g = ganzePositiv(max) ? max : LOGO_MAX;
    return Math.min(m, g);
  }

  // Preis einer Band-Variante in Cent: eigener Variantenpreis, sonst der Produktpreis.
  function bandPreis(daten, id) {
    var v = daten.band.varianten || [];
    for (var i = 0; i < v.length; i++) {
      if (String(v[i].id) === String(id) && typeof v[i].preis === 'number') return v[i].preis;
    }
    return daten.band.preis;
  }

  function varianteNachId(daten, id) {
    var v = (daten.band && daten.band.varianten) || [];
    for (var i = 0; i < v.length; i++) if (String(v[i].id) === String(id)) return v[i];
    return null;
  }

  /* Armband 1 aus der Wahl des Blocks: { id, farbe, groesse } oder null. Farbe und
     Groesse aus den eigenen Band-Varianten (die Galerie haengt daran), sonst vom Block. */
  function band1Aus(b, daten) {
    var id = b && typeof b === 'object' ? Number(b.variantId) : NaN;
    if (!ganzePositiv(id)) return null;
    var v = varianteNachId(daten, id);
    return { id: id, farbe: v ? v.farbe : String(b.farbe || ''), groesse: v ? v.groesse : String(b.groesse || '') };
  }

  /* Wahl des Blocks „Angebot & Farbe" lesen (window.lcVereinAngebot, Objekt oder Funktion).
     Ergebnis: { modus: 'einzeln'|'paar', band1: { id, farbe, groesse } | null, band1Fehlt: bool,
                 zweitesBand: { id, preis } | null, fehlt: bool }.
     band1Fehlt = der Block meldet band1, aber kein gueltiges -> kein Kauf. Meldet er gar
     kein band1 (kein Block / aelterer Block), ist band1 null und band1Fehlt false: dann
     gilt die Startvariante des Baukastens.
     fehlt = 'paar' gewaehlt, aber kein gueltiges zweites Band -> kein Kauf.
     Preis des zweiten Bands: zweitesBand.preis (Cent), sonst aus den Band-Varianten
     des Baukastens, sonst der Produktpreis des Bands. */
  function angebotLesen(roh, daten) {
    var w = roh;
    try { if (typeof w === 'function') w = w(); } catch (e) { w = null; }
    var leer = { modus: 'einzeln', band1: null, band1Fehlt: false, zweitesBand: null, fehlt: false };
    if (!w || typeof w !== 'object') return leer;
    var meldet = Object.prototype.hasOwnProperty.call(w, 'band1');
    var b1 = meldet ? band1Aus(w.band1, daten) : null;
    var basis = { band1: b1, band1Fehlt: meldet && !b1 };
    if (w.modus !== 'paar') return { modus: 'einzeln', band1: basis.band1, band1Fehlt: basis.band1Fehlt, zweitesBand: null, fehlt: false };
    var zb = w.zweitesBand;
    var id = zb && typeof zb === 'object' ? Number(zb.variantId) : NaN;
    if (!ganzePositiv(id)) return { modus: 'paar', band1: basis.band1, band1Fehlt: basis.band1Fehlt, zweitesBand: null, fehlt: true };
    var p = zb.preis;
    var preisZwei = (typeof p === 'number' && isFinite(p) && p >= 0 && Math.floor(p) === p) ? p : bandPreis(daten, id);
    return { modus: 'paar', band1: basis.band1, band1Fehlt: basis.band1Fehlt, zweitesBand: { id: id, preis: preisZwei }, fehlt: false };
  }

  /* Hauptposten: Armband 1 des Blocks; meldet der Block keins, die Startvariante
     (daten.start); meldet er ein ungueltiges, null (-> pruefen meldet es). */
  function hauptBand(ang, daten) {
    if (ang.band1) return ang.band1.id;
    if (ang.band1Fehlt) return null;
    var s = daten.start != null ? varianteNachId(daten, daten.start) : null;
    if (!s) s = ((daten.band && daten.band.varianten) || [])[0] || null;
    return s ? s.id : null;
  }

  // Einzelpreise aller Teile in Cent – Grundlage fuer Summe und Versandschwelle.
  function teile(auswahl, daten) {
    var t = [bandPreis(daten, auswahl.band)];
    if (auswahl.logo && daten.logo) {
      var n = logoMenge(auswahl.logoMenge, logoMax(daten));
      for (var i = 0; i < n; i++) t.push(daten.logo.preis);
    }
    auswahl.gravuren.forEach(function () { t.push(daten.gravur.preis); });
    if (auswahl.foto && daten.foto) t.push(daten.foto.preis);
    auswahl.extras.forEach(function (id) { t.push(extraPreis(daten, id)); });
    if (auswahl.zweitesBand) t.push(auswahl.zweitesBand.preis);
    return t;
  }

  /* Spiegel der Rabatt-Funktion "1+1" (seit 29.09.2026): gratis ist hoechstens das
     guenstigere von ZWEI berechtigten Armbaendern (Kollektion 1-1-angebot). Charms,
     Logo, Foto sind nie berechtigt. Ohne zweites Band ist hier also nichts gratis;
     mit zweitem Band (modus 'paar') das guenstigere der beiden. Gratisversand prueft
     Shopify NACH dem Rabatt. Die Leiste rechnet den Baukasten allein, massgeblich
     bleibt der Warenkorb (liegt dort schon ein Armband, rechnet die Kasse anders). */
  function preis(auswahl, daten) {
    var t = teile(auswahl, daten);
    var summe = t.reduce(function (a, b) { return a + b; }, 0);
    var gratis = auswahl.zweitesBand ? Math.min(bandPreis(daten, auswahl.band), auswahl.zweitesBand.preis) : 0;
    var zahlen = summe - gratis;
    return { teile: t.length, summe: summe, gratis: gratis, zahlen: zahlen,
             fehlt: Math.max(0, daten.schwelle - zahlen) };
  }

  // Zeile fuer "Wie viele Gravur-Charms?" (Betreiber 28.09.2026): was n Charms gegenueber einem
  // Charm mehr kosten (gleiche uebrige Auswahl). Seit 1+1 (29.09.2026) immer der volle Aufpreis:
  // Charms sind nie im Angebot, also nichts gratis und nichts durchgestrichen. Die Liste bleibt
  // ein eigener Baustein (Name links, Preis rechts), die <select> ist nur der Wertspeicher.
  function mitGravuren(a, n) {
    var g = [];
    for (var i = 0; i < n; i++) g.push('x');
    return { band: a.band, logo: a.logo, logoMenge: a.logoMenge, gravuren: g, schrift: a.schrift, foto: a.foto,
             extras: a.extras, zweitesBand: a.zweitesBand };
  }
  function anzahlTeile(n, a, daten, format) {
    if (n === 1) return { name: '1 Charm', preis: '' };
    var mehr = preis(mitGravuren(a, n), daten).zahlen - preis(mitGravuren(a, 1), daten).zahlen;
    return { name: n + ' Charms', preis: '+' + geld(mehr, format) };
  }
  // Klartext fuer die unsichtbare <select> (Wertspeicher, Bildschirmleser ohne JS).
  function anzahlText(n, a, daten, format) {
    var t = anzahlTeile(n, a, daten, format);
    return t.name + (t.preis ? ' (' + t.preis + ')' : '');
  }

  function pruefen(auswahl, daten) {
    var fehler = [];
    if (!auswahl.band) fehler.push({ schritt: 'angebot', text: TEXTE.bandFehlt });
    if (auswahl.gravuren.length === 0) {
      fehler.push({ schritt: 'gravur', text: TEXTE.keineGravur });
    }
    var gmax = gravurMax(daten);
    if (auswahl.gravuren.length > gmax) {
      fehler.push({ schritt: 'gravur', text: TEXTE.zuVieleGravuren.replace('{n}', String(gmax)) });
    }
    var leer = [];
    auswahl.gravuren.forEach(function (t, i) {
      if (!String(t == null ? '' : t).trim()) leer.push(i);
    });
    if (leer.length) fehler.push({ schritt: 'gravur', text: TEXTE.gravurLeer, felder: leer });
    if (auswahl.zweitesBandFehlt) fehler.push({ schritt: 'angebot', text: TEXTE.zweitesBandFehlt });
    return fehler;
  }

  // Reihenfolge = Bauweise: Band (Hauptposten), Logo, Gravuren, Foto, Extras, zweites Band.
  // Logo x N = EINE Zeile mit quantity N und derselben Datei (ein Upload).
  function posten(auswahl, daten) {
    var weitere = [];
    if (auswahl.logo && daten.logo) {
      weitere.push({ id: daten.logo.variante, quantity: logoMenge(auswahl.logoMenge, logoMax(daten)),
                     properties: { Bild: auswahl.logo } });
    }
    auswahl.gravuren.forEach(function (t) {
      weitere.push({ id: daten.gravur.variante, quantity: 1,
        properties: { Gravur: kuerzen(String(t).trim()), Schriftart: auswahl.schrift } });
    });
    if (auswahl.foto && daten.foto) {
      weitere.push({ id: daten.foto.variante, quantity: 1, properties: { Bild: auswahl.foto } });
    }
    auswahl.extras.forEach(function (id) {
      weitere.push({ id: Number(id), quantity: 1, properties: {} });
    });
    // 1+1: das zweite Band, nur das Band (Betreiber 14.10.2026).
    if (auswahl.zweitesBand) {
      weitere.push({ id: Number(auswahl.zweitesBand.id), quantity: 1, properties: {} });
    }
    return { haupt: auswahl.band, weitere: weitere };
  }

  // Ein Band: nur die Versandzeile (text leer -> Zeile ausgeblendet). Mit zweitem Band (1+1)
  // zusaetzlich der gruene Satz, dass das guenstigere Band gratis ist.
  function hinweis(p, format) {
    var versand = p.fehlt === 0 ? TEXTE.gratisVersand : 'Noch ' + geld(p.fehlt, format) + TEXTE.bisVersand;
    if (p.gratis > 0) return { text: TEXTE.gratisBand, gruen: true, versand: versand };
    return { text: '', gruen: false, versand: versand };
  }

  /* ── DOM-Schicht ── */

  function aufbereiten(datei) {
    var p = window.lcPersonalisierung;
    if (p && typeof p.aufbereiten === 'function') return p.aufbereiten(datei);
    if (p && p._intern && typeof p._intern.aufbereiten === 'function') return p._intern.aufbereiten(datei);
    return Promise.resolve(datei);
  }

  function starten(wurzel) {
    if (!wurzel || wurzel.getAttribute('data-lc-dva-an')) return;
    wurzel.setAttribute('data-lc-dva-an', '1');
    var datenKnoten = wurzel.querySelector('[data-lc-dv-daten]');
    var daten;
    try { daten = JSON.parse(datenKnoten.textContent); } catch (e) { return; }

    function q(s) { return wurzel.querySelector(s); }
    function qa(s) { return Array.prototype.slice.call(wurzel.querySelectorAll(s)); }

    // Armband 1 (Farbe, Groesse) waehlt der Block in Schritt ①, siehe band1Jetzt().
    var z = { logo: null, logoMenge: 1, anzahl: 1, schrift: 'Druckschrift', foto: null, extras: [] };
    var lmax = logoMax(daten);
    var auswahlAnzahl = q('[data-lc-dv-anzahl]');
    var wahlKnopf = q('[data-lc-dv-wahl-knopf]');
    var wahlListe = q('[data-lc-dv-wahl-liste]');
    var wahlText = q('[data-lc-dv-wahl-text]');
    if (auswahlAnzahl) z.anzahl = Number(auswahlAnzahl.value);

    function fehlerZeigen(schritt, text) {
      var f = q('[data-lc-dv-fehler="' + schritt + '"]');
      if (f) { f.textContent = text; f.hidden = false; }
    }
    function fehlerWeg(schritt) {
      var f = q('[data-lc-dv-fehler="' + schritt + '"]');
      if (f) f.hidden = true;
    }

    var felder = qa('[data-lc-dv-feld]');

    function auswahl() {
      var gravuren = [];
      felder.forEach(function (f, i) {
        if (i < z.anzahl) gravuren.push(f.querySelector('[data-lc-dv-gravur]').value);
      });
      var ang = angebotLesen(window.lcVereinAngebot, daten);
      return { band: hauptBand(ang, daten), logo: z.logo, logoMenge: z.logoMenge, gravuren: gravuren, schrift: z.schrift,
               foto: z.foto, extras: z.extras.slice(), zweitesBand: ang.zweitesBand, zweitesBandFehlt: ang.fehlt };
    }

    // Anzahl Logo-Charms: Stepper zeigt Wert, Grenzen und den Betrag fuer N Logos.
    var logoMengeKnoten = q('[data-lc-dv-logomenge]');
    function logoMengeZeichnen() {
      if (!logoMengeKnoten) return;
      logoMengeKnoten.hidden = !z.logo;
      var wert = q('[data-lc-dv-logo-wert]');
      if (wert) wert.textContent = String(z.logoMenge);
      var minus = q('[data-lc-dv-logo-minus]');
      var plus = q('[data-lc-dv-logo-plus]');
      if (minus) minus.disabled = z.logoMenge <= 1;
      if (plus) plus.disabled = z.logoMenge >= lmax;
      var summe = q('[data-lc-dv-logo-summe]');
      if (summe && daten.logo) summe.textContent = geld(daten.logo.preis * z.logoMenge, daten.format);
    }

    function leisteZeichnen() {
      logoMengeZeichnen();
      var p = preis(auswahl(), daten);
      if (auswahlAnzahl) {
        var basis = auswahl();
        Array.prototype.forEach.call(auswahlAnzahl.options, function (o) {
          o.textContent = anzahlText(Number(o.value), basis, daten, daten.format);
        });
        wahlZeichnen(basis);
      }
      var h = hinweis(p, daten.format);
      q('[data-lc-dv-teile]').textContent = p.teile + (p.teile === 1 ? ' Teil' : ' Teile');
      q('[data-lc-dv-alt]').textContent = p.gratis ? geld(p.summe, daten.format) : '';
      q('[data-lc-dv-summe]').textContent = geld(p.zahlen, daten.format);
      var hk = q('[data-lc-dv-hinweis]');
      if (hk) {
        hk.textContent = h.text;
        hk.hidden = !h.text;
        hk.classList.toggle('lc-dv__hinweis--gruen', h.gruen);
      }
      q('[data-lc-dv-versand]').textContent = h.versand;
      // Kopfpreis zeigt denselben Betrag wie die Leiste (Spec 3.2 Nachtrag 11).
      var kopfAlt = q('[data-lc-dv-kopfalt]');
      if (kopfAlt) kopfAlt.textContent = p.gratis ? geld(p.summe, daten.format) : '';
      var kopfSumme = q('[data-lc-dv-kopfsumme]');
      if (kopfSumme) kopfSumme.textContent = geld(p.zahlen, daten.format);
      platzHalten();   // Texte in der Leiste aendern ihre Hoehe
    }

    // Kaufleiste: erst normal im Fluss wie auf der Produktseite. Ist ihr Platz nach oben aus dem
    // Bild gescrollt, steht sie am Handy fest unten (Klasse --fest), ueber die ganze Seite. Der
    // Platzhalter haelt die Hoehe (nichts springt), der body bekommt unten Platz (Seitenende frei).
    // Scroll-Ereignis statt IntersectionObserver: laeuft auch im verdeckten Testfenster.
    var leiste = q('[data-lc-dv-leiste]');
    var kaufplatz = q('[data-lc-dv-kaufplatz]');
    var handy = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    function platzHalten() {
      if (!leiste || !kaufplatz) return;
      var fest = !!(handy && handy.matches) && kaufplatz.getBoundingClientRect().bottom < 0;
      if (fest && !leiste.classList.contains('lc-dv__leiste--fest')) kaufplatz.style.minHeight = leiste.offsetHeight + 'px';
      if (!fest) kaufplatz.style.minHeight = '';
      leiste.classList.toggle('lc-dv__leiste--fest', fest);
      document.body.style.paddingBottom = fest ? leiste.offsetHeight + 'px' : '';
    }
    if (leiste && kaufplatz) {
      platzHalten();
      window.addEventListener('scroll', platzHalten, { passive: true });
      window.addEventListener('resize', platzHalten);
      if (window.ResizeObserver) new ResizeObserver(platzHalten).observe(leiste);
    }

    // Galerie: wischen wie auf der Produktseite, Punkte folgen dem Bild.
    // Seit 14.10.2026 nach Farbe (Ansage des Betreibers): Folien und Punkte anderer Farben tragen
    // hidden. Alle Indizes unten zaehlen darum nur die SICHTBAREN (versteckte Folien nehmen in
    // der Bahn keinen Platz ein, scrollLeft / Breite ist also schon der sichtbare Index).
    var bahn = q('[data-lc-dv-bahn]');
    var slides = qa('[data-lc-dv-slide]');
    var punkte = qa('[data-lc-dv-punkt]');
    var punkteLeiste = punkte.length ? punkte[0].parentNode : null;
    var slideIds = slides.map(function (s) { return s.getAttribute('data-lc-dv-slide'); });
    var folienFarben = slides.map(function (s) { return s.getAttribute('data-lc-dv-farbe'); });
    var punktFarben = punkte.map(function (p) { return p.getAttribute('data-lc-dv-farbe'); });
    // Ohne Farbmerkmale (Rueckfall im Liquid) bleibt die Galerie wie vorher: alle Bilder,
    // die Farbwahl springt per slideFuerFarbe auf das Bild der Farbe.
    var nachFarbe = folienFarben.some(function (f) { return f != null && f !== ''; });
    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function sichtbar(liste) { return liste.filter(function (x) { return !x.hidden; }); }
    function punktSetzen(i) {
      var an = sichtbar(punkte)[i];
      punkte.forEach(function (p) {
        p.classList.toggle('lc-dv__punkt--an', p === an);
        if (p === an) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
      });
    }
    function zuSlide(i, weich) {
      var s = sichtbar(slides);
      if (!bahn || i < 0 || i >= s.length) return;
      bahn.scrollTo({ left: s[i].offsetLeft, behavior: weich && !ruhig ? 'smooth' : 'auto' });
      punktSetzen(i);
    }
    // Nur die Bilder einer Farbe zeigen (Folien UND Punkte), dann auf ihr erstes Bild, ohne
    // weiches Scrollen: der Inhalt der Bahn wechselt ja. Unter 2 sichtbaren Bildern keine Punkte.
    function farbeZeigen(farbe) {
      var an = sichtbareFolien(folienFarben, farbe);
      slides.forEach(function (s, i) { s.hidden = an.indexOf(i) === -1; });
      var pan = sichtbareFolien(punktFarben, farbe);
      punkte.forEach(function (p, i) { p.hidden = pan.indexOf(i) === -1; });
      var sp = sichtbar(punkte);
      sp.forEach(function (p, k) { p.setAttribute('aria-label', 'Bild ' + (k + 1) + ' von ' + sp.length); });
      if (punkteLeiste) punkteLeiste.hidden = an.length < 2;
      zuSlide(0, false);
    }
    if (bahn && slides.length) {
      // Direkt im Scroll-Ereignis, ohne requestAnimationFrame: 13 Klassen umschalten ist
      // billig, und rAF laeuft in verdeckten Fenstern gar nicht.
      bahn.addEventListener('scroll', function () {
        punktSetzen(Math.round(bahn.scrollLeft / Math.max(bahn.clientWidth, 1)));
      }, { passive: true });
      punkte.forEach(function (p) {
        p.addEventListener('click', function () { zuSlide(sichtbar(punkte).indexOf(p), true); });
      });
    }

    // Galerie folgt der Farbe von Armband 1 (Zeile 1 im Block „Angebot & Farbe"). Nachgezogen
    // wird beim Start und wenn sich die FARBE aendert (eine neue Groesse laesst das Bild stehen):
    // nach Farbe tauschen die Bilder (farbeZeigen), im Rueckfall springt die Bahn aufs Farbbild.
    function band1Jetzt() {
      var id = hauptBand(angebotLesen(window.lcVereinAngebot, daten), daten);
      return id ? varianteNachId(daten, id) : null;
    }
    var galerieFarbe = null;
    function galerieNachziehen(weich) {
      var b = band1Jetzt();
      if (!b || b.farbe === galerieFarbe) return;
      galerieFarbe = b.farbe;
      if (nachFarbe) { farbeZeigen(b.farbe); return; }
      zuSlide(slideFuerFarbe(daten.band.varianten, b.farbe, b.groesse, slideIds), weich);
    }
    galerieNachziehen(false);

    // Groessenhilfe
    var fenster = q('[data-lc-dv-fenster]');
    if (fenster) {
      qa('[data-lc-dv-hilfe]').forEach(function (k) {
        k.addEventListener('click', function () { fenster.hidden = false; });
      });
      qa('[data-lc-dv-zu]').forEach(function (k) {
        k.addEventListener('click', function () { fenster.hidden = true; });
      });
      fenster.addEventListener('click', function (e) { if (e.target === fenster) fenster.hidden = true; });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !fenster.hidden) fenster.hidden = true;
      });
    }

    // Zaehler fuer laufende Bildaufbereitungen (Logo + Foto teilen sich ihn):
    // solange er > 0 ist, darf nicht gekauft werden.
    var bildLaeuft = 0;

    // Upload: Logo-Schritt und Foto-Karte laufen gleich verdrahtet.
    function uploadVerdrahten(kasten, setzen) {
      var eingabe = kasten.querySelector('[data-lc-dv-datei]');
      var leertext = kasten.querySelector('[data-lc-dv-leertext]');
      var vorschau = kasten.querySelector('[data-lc-dv-vorschau]');
      var name = kasten.querySelector('[data-lc-dv-name]');
      var fehler = kasten.querySelector('[data-lc-dv-upfehler]');
      var leer = leertext ? leertext.textContent : '';
      var url = null;
      var fertigAktuell = null;
      var nameAktuell = '';

      // Laufnummer gegen ueberholte Ergebnisse: zwei aufbereiten()-Aufrufe fuer
      // denselben Kasten koennen in beliebiger Reihenfolge fertig werden (zweite
      // Datei waehlen waehrend die erste noch laeuft, oder Entfernen waehrend
      // eine Aufbereitung laeuft - auch per Tastatur, nicht nur per Maus). Nur
      // das Ergebnis der zuletzt gestarteten Anfrage darf anzeigen()/leeren()
      // noch anfassen.
      var anfrage = 0;

      function leeren() {
        if (url) { URL.revokeObjectURL(url); url = null; }
        fertigAktuell = null;
        nameAktuell = '';
        setzen(null);
        eingabe.value = '';
        kasten.classList.remove('lc-dv__upload--voll');
        if (vorschau) vorschau.removeAttribute('src');
        if (name) name.textContent = '';
        leisteZeichnen();
      }

      // Zeigt ein gueltiges Bild an – neu aufbereitet, oder beim Fehlschlag
      // wieder das vorherige (siehe change-Handler).
      function anzeigen(fertig, angezeigterName, neueUrl) {
        if (url && url !== neueUrl) URL.revokeObjectURL(url);
        url = neueUrl;
        fertigAktuell = fertig;
        nameAktuell = angezeigterName;
        if (vorschau) vorschau.src = url;
        if (name) name.textContent = angezeigterName;
        kasten.classList.add('lc-dv__upload--voll');
        setzen(fertig);
      }

      eingabe.addEventListener('change', function () {
        var datei = eingabe.files && eingabe.files[0];
        if (!datei) return;
        if (fehler) fehler.hidden = true;
        var vorherFertig = fertigAktuell;
        var vorherUrl = url;
        var vorherName = nameAktuell;
        var meine = ++anfrage;
        bildLaeuft++;
        kasten.classList.add('lc-dv__upload--arbeitet');
        if (leertext) leertext.textContent = TEXTE.vorbereiten;
        if (name) name.textContent = TEXTE.vorbereiten;
        setzen(null);                                   // altes Bild geht bis zum Abschluss nicht mit
        // Ueber Promise.resolve().then() gerufen: ein synchroner Wurf aus
        // aufbereiten() (z. B. lc-personalisierung.js fehlt ganz) wuerde sonst
        // bildLaeuft nie wieder runterzaehlen und den Kauf dauerhaft sperren.
        Promise.resolve().then(function () { return aufbereiten(datei); }).then(function (fertig) {
          bildLaeuft--;
          bildLaeuftMeldungWeg();
          if (meine !== anfrage) return;                 // ueberholt: neuere Wahl oder Entfernen war schneller
          kasten.classList.remove('lc-dv__upload--arbeitet');
          if (leertext) leertext.textContent = leer;
          anzeigen(fertig, datei.name, URL.createObjectURL(fertig));
          leisteZeichnen();
        }, function (e) {
          bildLaeuft--;
          bildLaeuftMeldungWeg();
          if (meine !== anfrage) return;                 // ueberholt: nichts mehr anfassen
          kasten.classList.remove('lc-dv__upload--arbeitet');
          if (leertext) leertext.textContent = leer;
          if (vorherFertig) { anzeigen(vorherFertig, vorherName, vorherUrl); }  // vorheriges Bild bleibt gueltig
          else leeren();
          if (fehler) { fehler.textContent = (e && e.meldung) || TEXTE.bildFehler; fehler.hidden = false; }
          leisteZeichnen();
        });
      });
      Array.prototype.forEach.call(kasten.querySelectorAll('[data-lc-dv-aendern]'), function (k) {
        k.addEventListener('click', function () { eingabe.click(); });
      });
      // Die Upload-Beschriftung (.lc-dv__upknopf beim Logo, .lc-dv__plus bei der
      // Foto-Karte) ist ein <label> mit tabindex="0" + role="button": ein <label>
      // reagiert von sich aus nicht auf Enter/Leertaste, nur auf Klick.
      var beschriftung = kasten.querySelector('.lc-dv__upknopf, .lc-dv__plus');
      if (beschriftung) {
        beschriftung.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { eingabe.click(); }
          else if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); eingabe.click(); }
        });
      }
      Array.prototype.forEach.call(kasten.querySelectorAll('[data-lc-dv-entfernen]'), function (k) {
        // anfrage++ entwertet eine noch laufende Aufbereitung (Maus- UND
        // Tastaturpfad ueber diesen Klick-Handler), damit ihr spaetes Ergebnis
        // dieses Entfernen nicht rueckgaengig macht.
        // Der Laufzustand wird hier mit zurueckgesetzt: das entwertete Ergebnis
        // kehrt vorzeitig zurueck und wuerde ihn sonst nie aufheben (Kasten
        // bliebe per pointer-events gesperrt).
        k.addEventListener('click', function () {
          anfrage++;
          kasten.classList.remove('lc-dv__upload--arbeitet');
          if (leertext) leertext.textContent = leer;
          if (fehler) fehler.hidden = true;
          leeren();
        });
      });
    }

    var logoKasten = q('[data-lc-dv-upload="logo"]');
    if (logoKasten) uploadVerdrahten(logoKasten, function (f) { z.logo = f; logoMengeZeichnen(); });
    function logoMengeSetzen(n) {
      z.logoMenge = logoMenge(n, lmax);
      leisteZeichnen();
    }
    qa('[data-lc-dv-logo-minus]').forEach(function (k) {
      k.addEventListener('click', function () { logoMengeSetzen(z.logoMenge - 1); });
    });
    qa('[data-lc-dv-logo-plus]').forEach(function (k) {
      k.addEventListener('click', function () { logoMengeSetzen(z.logoMenge + 1); });
    });
    var fotoKarte = q('[data-lc-dv-upload="foto"]');
    if (fotoKarte) uploadVerdrahten(fotoKarte, function (f) {
      z.foto = f;
      fotoKarte.classList.toggle('lc-dv__karte--an', !!f);
    });

    // Gravur: Anzahl (Dropdown 1..gravurMax, Liquid rendert die Optionen), Felder, Schriftart
    function felderZeigen() {
      felder.forEach(function (f, i) { f.hidden = i >= z.anzahl; });
    }
    // Eigene Auswahlliste (Name links, Aufpreis rechts). Sie setzt nur den Wert der unsichtbaren
    // <select> und loest deren change aus; alles andere bleibt, wie es war.
    function zeileBauen(ziel, t) {
      ziel.textContent = '';
      var name = document.createElement('span');
      name.className = 'lc-dv__wahl-name';
      name.textContent = t.name;
      ziel.appendChild(name);
      if (!t.preis) return;
      var pr = document.createElement('span');
      pr.className = 'lc-dv__wahl-preis';
      pr.textContent = t.preis;
      ziel.appendChild(pr);
    }
    function wahlZeichnen(basis) {
      if (!wahlListe || !auswahlAnzahl) return;
      wahlListe.textContent = '';
      Array.prototype.forEach.call(auswahlAnzahl.options, function (o) {
        var n = Number(o.value);
        var t = anzahlTeile(n, basis, daten, daten.format);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lc-dv__wahl-option';
        b.setAttribute('role', 'option');
        b.setAttribute('aria-selected', n === z.anzahl ? 'true' : 'false');
        b.setAttribute('data-wert', String(n));
        zeileBauen(b, t);
        wahlListe.appendChild(b);
        if (n === z.anzahl && wahlText) zeileBauen(wahlText, t);
      });
    }
    function wahlZu() {
      if (!wahlListe || wahlListe.hidden) return;
      wahlListe.hidden = true;
      wahlKnopf.setAttribute('aria-expanded', 'false');
    }
    if (wahlKnopf && wahlListe && auswahlAnzahl) {
      wahlKnopf.addEventListener('click', function () {
        var auf = wahlListe.hidden;
        wahlListe.hidden = !auf;
        wahlKnopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
        var an = auf && wahlListe.querySelector('[aria-selected="true"]');
        if (an) an.focus();
      });
      wahlListe.addEventListener('click', function (e) {
        var o = e.target.closest('[data-wert]');
        if (!o) return;
        auswahlAnzahl.value = o.getAttribute('data-wert');
        auswahlAnzahl.dispatchEvent(new Event('change', { bubbles: true }));
        wahlZu();
        wahlKnopf.focus();
      });
      document.addEventListener('click', function (e) {
        if (!wahlKnopf.parentNode.contains(e.target)) wahlZu();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !wahlListe.hidden) { wahlZu(); wahlKnopf.focus(); }
      });
    }

    if (auswahlAnzahl) {
      auswahlAnzahl.addEventListener('change', function () {
        z.anzahl = Number(auswahlAnzahl.value);
        felderZeigen();
        fehlerWeg('gravur');
        leisteZeichnen();
      });
    }
    felder.forEach(function (f) {
      var e = f.querySelector('[data-lc-dv-gravur]');
      var zl = f.querySelector('[data-lc-dv-zaehler]');
      function nachziehen() {
        var k = kuerzen(e.value);
        if (k !== e.value) e.value = k;
        if (zl) zl.textContent = String(zaehlen(e.value));
        e.classList.remove('lc-dv__eingabe--fehlt');
        fehlerWeg('gravur');
      }
      e.addEventListener('input', function (ev) { if (!ev.isComposing) nachziehen(); });
      e.addEventListener('compositionend', nachziehen);
    });

    // Karten: Plus waehlt aus (kein Sofortkauf)
    qa('[data-lc-dv-karte]').forEach(function (karte) {
      var id = karte.getAttribute('data-lc-dv-karte');
      if (id === 'foto') return;
      var plus = karte.querySelector('[data-lc-dv-plus]');
      if (!plus) return;
      plus.addEventListener('click', function () {
        var i = z.extras.indexOf(id);
        var jetztAn = i === -1;
        if (jetztAn) z.extras.push(id); else z.extras.splice(i, 1);
        karte.classList.toggle('lc-dv__karte--an', jetztAn);
        plus.setAttribute('aria-pressed', jetztAn ? 'true' : 'false');
        leisteZeichnen();
      });
    });

    // Kaufen
    var kaufen = q('[data-lc-dv-kaufen]');
    var kaufFehler = q('[data-lc-dv-kauffehler]');
    var laeuft = false;
    function ende() {
      kaufen.textContent = TEXTE.knopf;
      kaufen.disabled = false;
      kaufen.removeAttribute('aria-busy');
      laeuft = false;
    }
    function kaufFehlerZeigen() { kaufFehler.textContent = TEXTE.fehler; kaufFehler.hidden = false; }
    // Blendet die Kauf-Meldung "Bild wird vorbereitet ..." aus, sobald keine
    // Aufbereitung mehr laeuft (bildLaeuft wieder 0) - aber nur, wenn genau
    // diese Meldung gerade steht. Ein anderer Kauf-Fehler soll dadurch nicht
    // verschwinden.
    function bildLaeuftMeldungWeg() {
      if (!bildLaeuft && !kaufFehler.hidden && kaufFehler.textContent === TEXTE.vorbereiten) {
        kaufFehler.hidden = true;
      }
    }

    kaufen.addEventListener('click', function () {
      if (laeuft) return;
      if (bildLaeuft) { kaufFehler.textContent = TEXTE.vorbereiten; kaufFehler.hidden = false; return; }
      kaufFehler.hidden = true;
      felder.forEach(function (f) { f.querySelector('[data-lc-dv-gravur]').classList.remove('lc-dv__eingabe--fehlt'); });
      var a = auswahl();
      var fehler = pruefen(a, daten);
      if (fehler.length) {
        var ziel = null;
        fehler.forEach(function (f) {
          fehlerZeigen(f.schritt, f.text);
          (f.felder || []).forEach(function (i) {
            var e = felder[i].querySelector('[data-lc-dv-gravur]');
            e.classList.add('lc-dv__eingabe--fehlt');
            if (!ziel) ziel = e;
          });
          if (!ziel && f.schritt === 'angebot') ziel = q('[data-lc-verein-angebot]');
          if (!ziel) ziel = q('[data-lc-dv-schritt="' + f.schritt + '"]') || q('[data-lc-dv-schritt="gravur"]');
        });
        if (ziel) {
          try { ziel.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
          if (ziel.tagName === 'INPUT') { try { ziel.focus({ preventScroll: true }); } catch (e) {} }
        }
        return;
      }
      var korb = window.lcKorb;
      if (!a.band || !korb || typeof korb.hinzufuegen !== 'function') { kaufFehlerZeigen(); return; }
      // lcKorb.gravur ist zusammen mit dem Datei-Weg im Easify-Ersatz dazugekommen
      // (12.09.2026): eine aeltere lc-korb.js ohne Datei-Weg (z. B. nach einem
      // Rueckweg) kennt Logo/Foto in `weitere` nicht, laesst sie beim Senden
      // still fallen und meldet trotzdem Erfolg. lcKorb.gravur dient hier als
      // Merkmal "Datei-Weg vorhanden" - ohne das lieber gar nicht erst senden.
      if ((a.logo || a.foto) && !korb.gravur) { kaufFehlerZeigen(); return; }

      laeuft = true;
      kaufen.disabled = true;
      kaufen.setAttribute('aria-busy', 'true');
      kaufen.textContent = TEXTE.laeuft;
      var p = posten(a, daten);
      var optionen = (a.logo || a.foto) ? {
        beiFortschritt: function (x) {
          if (x >= 1) { kaufen.textContent = TEXTE.laeuft; return; }
          kaufen.textContent = TEXTE.upload + Math.round(x * 100) + ' %';
        }
      } : {};
      var lauf;
      try { lauf = korb.hinzufuegen(p.haupt, 1, {}, p.weitere, 'dein-verein', optionen); }
      catch (e) { lauf = Promise.reject(e); }
      Promise.resolve(lauf).then(function (antwort) {
        if (antwort === false) { ende(); return; }              // Doppeltipp-Riegel: nichts Neues im Korb
        if (antwort && antwort.ok === false) throw new Error('HTTP ' + antwort.status);
        kaufen.textContent = TEXTE.fertig;                      // undefined = alte lc-korb.js, die nichts zurueckgibt
        setTimeout(ende, 2000);
      }).catch(function () {
        // Erst den Warenkorb schliessen: sonst bleibt er ueber der Fehlermeldung
        // offen stehen, waehrend lc-korb.js selbst bis oeffnen() weiterlaeuft.
        try { if (window.lcKorb && window.lcKorb.schliessen) window.lcKorb.schliessen(); } catch (e) {}
        kaufFehlerZeigen();
        ende();
      });
    });

    // Block „Angebot & Farbe": Wahl ueber window.lcVereinAngebot. Neu zeichnen, wenn sie sich
    // geaendert hat — beim Ereignis lc:verein-angebot und nach jedem Klick/Wechsel auf der Seite
    // (erst im naechsten Takt, falls der Block die Wahl in seinem eigenen Handler setzt).
    function angebotStempel() {
      var ang = angebotLesen(window.lcVereinAngebot, daten);
      return ang.modus + '|' + (hauptBand(ang, daten) || '-') + '|' +
        (ang.zweitesBand ? ang.zweitesBand.id + ':' + ang.zweitesBand.preis : '-');
    }
    var angebotZuletzt = angebotStempel();
    function angebotPruefen() {
      var jetzt = angebotStempel();
      if (jetzt === angebotZuletzt) return;
      angebotZuletzt = jetzt;
      fehlerWeg('angebot');
      galerieNachziehen(true);
      leisteZeichnen();
    }
    function spaeterPruefen() { setTimeout(angebotPruefen, 0); }
    document.addEventListener('lc:verein-angebot', angebotPruefen);
    document.addEventListener('click', spaeterPruefen);
    document.addEventListener('change', spaeterPruefen);

    felderZeigen();
    leisteZeichnen();
  }

  function alleStarten() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lc-dva]'), starten);
  }

  window.lcDeinVereinAngebot = {
    starten: starten,
    _intern: {
      TEXTE: TEXTE, geld: geld, kuerzen: kuerzen, zaehlen: zaehlen, variante: variante,
      bildFuerFarbe: bildFuerFarbe, slideFuerFarbe: slideFuerFarbe, sichtbareFolien: sichtbareFolien,
      anzahlText: anzahlText, anzahlTeile: anzahlTeile,
      teile: teile, preis: preis, pruefen: pruefen, posten: posten, hinweis: hinweis,
      gravurMax: gravurMax, logoMax: logoMax, logoMenge: logoMenge, bandPreis: bandPreis, angebotLesen: angebotLesen,
      band1Aus: band1Aus, hauptBand: hauptBand
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleStarten);
  else alleStarten();
  // Theme-Editor: neu eingefuegte/gespeicherte Section starten. Der Start-Riegel
  // (data-lc-dva-an) verhindert, dass alleStarten() bereits laufende doppelt startet.
  document.addEventListener('shopify:section:load', alleStarten);
})();
